export default[
    {
        path: '/comissionador/cadastro',
        name: 'cadastro do comissionador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/comissionador/lista',
        name: 'lista do comissionador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/comissionador/editar/:id',
        name: 'editar comissionador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]